import SendAndTrackView from './SendAndTrackView';

export default SendAndTrackView;
